(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clesana_side-by-side"] && !Shopify.designMode) return;
  try {
    
  // Autoplay videos that bypass <deferred-media> for Safari compatibility.
  // Safari does not reliably honour the autoplay attribute on <video> elements
  // inside custom elements. We render these videos directly and use an
  // IntersectionObserver to play them when they enter the viewport.
  (function () {
    var videos = document.querySelectorAll('video.clesana-autoplay-video');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    videos.forEach(function (video) {
      video.muted = true; // set property (not just attribute) — WebKit requires this
      var hasLoaded = false;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!hasLoaded) {
                video.load(); // force WebKit to evaluate sources after DOM insertion
                hasLoaded = true;
              }
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clesana_video-section"] && !Shopify.designMode) return;
  try {
    
  // Autoplay videos that bypass <deferred-media> for Safari compatibility.
  // Safari does not reliably honour the autoplay attribute on <video> inside
  // custom elements. We render these videos directly and use an
  // IntersectionObserver to play them when they enter the viewport.
  (function () {
    var videos = document.querySelectorAll('video.clesana-autoplay-video');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    for (const video of videos) {
      video.muted = true; // set property (not just attribute) — WebKit requires this
      let hasLoaded = false;
      const observer = new IntersectionObserver(
        function (entries) {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (!hasLoaded) {
                video.load(); // force WebKit to evaluate sources after DOM insertion
                hasLoaded = true;
              }
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(video);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
